import { render, staticRenderFns } from "./taskListPDF.vue?vue&type=template&id=555a7e6b&"
import script from "./taskListPDF.vue?vue&type=script&lang=js&"
export * from "./taskListPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports